export enum ProductCategoryFuel {
    'HFO_VLS' = 'HFO_VLS',
    'HFO_HS' = 'HFO_HS',
    'MGO_ULS' = 'MGO_ULS',
    'MGO_VLS' = 'MGO_VLS',
    'MDO_ULS' = 'MDO_ULS',
    'MDO_VLS' = 'MDO_VLS',
    'MDO_HS' = 'MDO_HS',
}
